module.exports = __webpack_public_path__ + "static/cortex-value-noman-min-590a2e589015a381bc1e3ee14927997c.png";